import request from '../request';
import { url } from './config';
import { AppSetting } from './types';

const handleData = (res: any) => res.data;

class AppSettingsApi {
    getAll(): Promise<AppSetting[]> {
        return request.get(url).then(handleData);
    }

    getByKey(key: string): Promise<AppSetting> {
        return request.get(`${url}/${key}`).then(handleData);
    }

    update(key: string, value: any): Promise<AppSetting> {
        return request.put(`${url}/${key}`, { value }).then(handleData);
    }

    listLocalDbs(): Promise<string[]> {
        return request.get(`${url}-local-dbs`).then(handleData);
    }
}

export default new AppSettingsApi();
